import React from "react";
import { Divider, FormControl, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import FuelCalculator from "../../Utils/FuelCalculator";
import { TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import { findById } from "../../Utils/ContextLookups";

export default function FuelFooter(props: TicketProps): JSX.Element {
    const aircraft = findById(props.aircraftList, props.ticket.aircraft_id);

    const ticketFuel = FuelCalculator.Calculate(props.ticket, aircraft);

    const toAllocateText = ticketFuel.fuelToAllocate.lt(0) ? "OVER ALLOCATED" : "REMAINING";
    const toAllocateColor = !ticketFuel.fuelToAllocate.eq(0) ? "warning.main" : "black";

    const col1width = 4.0;
    const col2width = 5.0;
    const col3width = 2.0;
    const col4width = 1.0;

    return (
        <Grid key={`${ticketFuel.allocatedFuel}`} container spacing={1} flexDirection={"row"}>
            <Grid xs={col1width} item container flexDirection={"column"}>
                <Grid item>
                    <FormControl fullWidth></FormControl>
                </Grid>
            </Grid>
            <Grid xs={col2width} item container flexDirection={"column"}>
                <Grid item>
                    <FormControl fullWidth></FormControl>
                </Grid>
                <Grid item>
                    <FormControl fullWidth sx={{ textAlign: "right" }}>
                        FUEL TO ALLOCATE
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl fullWidth sx={{ textAlign: "right" }}>
                        ALLOCATED
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl fullWidth sx={{ textAlign: "right", color: toAllocateColor }}>
                        <Typography color={toAllocateColor}>{toAllocateText}</Typography>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid xs={col3width} item container flexDirection={"column"}>
                <Grid item>
                    <FormControl fullWidth sx={{ textAlign: "right" }}>
                        <Divider />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl fullWidth sx={{ textAlign: "right", pr: 1.7 }}>
                        {ticketFuel.requiredFuel.toFixed(1)}
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl fullWidth sx={{ textAlign: "right", pr: 1.7 }}>
                        {ticketFuel.allocatedFuel.toFixed(1)}
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl fullWidth sx={{ textAlign: "right", pr: 1.7 }}>
                        <Typography color={toAllocateColor}>{ticketFuel.fuelToAllocate.toFixed(1)}</Typography>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid xs={col4width} item container flexDirection={"column"}></Grid>
        </Grid>
    );
}
